export default class ResponseConnectionErrorChannel extends Error {
  constructor(err, channel) {
    super();

    this.name = 'ResponseConnectionErrorChannel';
    this.errors = err;
    this.channel = channel;
  }
}
